import TestCaseReportPage from "@/pages/testCaseReport/TestCaseReportPage.vue";

export default [
  {
    path: '/testcase/',
    component: TestCaseReportPage,
    props: true
  }
]
